export default "__VITE_PUBLIC_ASSET__6aa1c71b__"